module.exports = __webpack_public_path__ + "static/media/american-football-cheerleader-jump.02dab031.svg";